<script>
import ProductService from "@/store/services/product.service.js";
import ArchiveBase from "@/components/base_components/ArchiveBase.vue";

export default {
    name: "ProductArchive",
    extends: ArchiveBase,
    methods: {
        extendable(){
            this.is_archived = !this.is_archived;
            this.item.archived = this.is_archived;
            ProductService.update(this.item.id, this.item).catch(function (response) {
                if (response.status == 403) {
                    // _showPremiumModal();
                } else {
                    console.error("Update product failed" + response);
                }
            });
        }
    }
};
</script>